import { Capacitor } from '@capacitor/core';
import { BiometricAuth } from '@aparajita/capacitor-biometric-auth';
import { secureSet, secureGet, secureRemove } from './secureStore';

const TOKEN_KEY = 'portal_bio_token';

let _authInProgress = false;
export function isBiometricPromptActive() { return _authInProgress; }

export async function isBiometricAvailable() {
  if (!Capacitor.isNativePlatform()) return false;
  try { const info = await BiometricAuth.checkBiometry(); return info.isAvailable; }
  catch { return false; }
}
export async function isBiometricEnabled() {
  if (!Capacitor.isNativePlatform()) return false;
  const t = await secureGet(TOKEN_KEY);
  return !!t;
}
export async function enableBiometric(token) {
  if (!token) return false;
  if (_authInProgress) return false;
  _authInProgress = true;
  try {
    await BiometricAuth.authenticate({ reason: 'Bevestig om vingerafdruk-login in te schakelen', cancelTitle: 'Annuleren' });
    await secureSet(TOKEN_KEY, token);
    return true;
  } catch (e) { console.log('[bio] enable geannuleerd', e && e.message); return false; }
  finally { _authInProgress = false; }
}
export async function tryBiometricLogin() {
  if (!(await isBiometricEnabled())) return null;
  if (_authInProgress) return null;
  _authInProgress = true;
  try {
    await BiometricAuth.authenticate({ reason: 'Inloggen met vingerafdruk of gezicht', cancelTitle: 'Gebruik wachtwoord' });
    return (await secureGet(TOKEN_KEY)) || null;
  } catch (e) { console.log('[bio] auth geannuleerd', e && e.message); return null; }
  finally { _authInProgress = false; }
}
export async function updateBiometricToken(token) {
  if (!token) return;
  if (!(await isBiometricEnabled())) return;
  await secureSet(TOKEN_KEY, token);
}
export async function disableBiometric() { await secureRemove(TOKEN_KEY); }
